import React, { useEffect } from "react";
import { connect } from "react-redux";

import ProductListOne from "~/components/partials/shop/product-list/product-list-one";
import {
  findProducts,
  getMenuCategories,
  getStoreBanners,
} from "~/graphql/api";
import { STORE_ID } from "~/config";
import fetchData from "~/utils/fetchData";
import NextHead from "~/components/common/next-head";
import { getPublicImageURL } from "~/utils/getPublicImageUrl";

import { Logger } from "aws-amplify";
import { eventActions } from "~/store/events";

const logger = new Logger("All collections");

function AllProduct(props) {
  const {
    store,
    products,
    pageFilter,
    categories,
    pageMeta,
    collectionViewed,
  } = props;
  const { name } = store || {};

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      collectionViewed({
        collectionId: "",
        title: "all",
        slug: "all",
        imageUrl: "",
      });
    }, 1000);
    return () => {
      clearTimeout(timeoutId);
    };
  }, []);

  return (
    <main className="main">
      {/* <NextHead {...pageMeta} /> */}

      <h1 className="d-none">{name} - All Products</h1>

      <div className="page-content pb-3">
        <div className="container">
          <div className="row main-content-wrap gutter-lg">
            <div className="col-lg-12 main-content">
              <ProductListOne
                sectionId="All"
                products={products}
                filterItems={categories}
                pageFilter={pageFilter}
              />
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}

export const getStaticProps = async () => {
  const filter = {
    status: { eq: "ENABLED" },
    storeId: { eq: STORE_ID },
  };

  //get all categories
  const { searchProductCategories } = await fetchData(getMenuCategories, {
    filter: {
      storeId: { eq: STORE_ID },
      isArchive: { eq: false },
    },
    sort: [{ field: "priority", direction: "asc" }],
  });

  const { getStore } = await fetchData(getStoreBanners, {
    id: STORE_ID,
    deviceType: "WEB",
  });
  const { title, name, description, webUrl, imageUrl } = getStore;

  const categories = [
    { name: "all", path: "/collections/all" },
    ...searchProductCategories.items.map((cat) => ({
      ...cat,
      path: `/collections/${cat.slug}`,
    })),
  ];

  // Get all Product
  const { searchProducts } = await fetchData(findProducts, {
    filter,
    sort: [{ field: "position", direction: "asc" }],
    variantFilter: { status: { eq: "ENABLED" } },
    imageLimit: 1,
  });

  return {
    props: {
      categories,
      products: searchProducts,
      pageFilter: filter,
      pageMeta: {
        siteName: name,
        title,
        description,
        canonical: `${webUrl}/collections/all`,
        image: getPublicImageURL(imageUrl),
      },
    },
    revalidate: 1800,
  };
};

function mapStateToProps(state) {
  return {
    store: state.system.store,
  };
}

const Component = connect(mapStateToProps, {
  collectionViewed: eventActions.collectionViewed,
})(React.memo(AllProduct));
Component.showStickyCheckout = true;
Component.showTopRunner = true;
Component.showTimer = true;

export default Component;
